export interface IAccountsPayableOpoDetail {
    opoId: number,
    opoAlias: string,
    recipientId: number,
    recipientAlias: string,
    achAccountNumber: string,
    invoiceDate: string,
    daysOutstanding: number,
    amount: number,
    isPaid: boolean
}